import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UsuariosProvider } from '../usuarios/usuarios';
import { ClientesProvider } from '../clientes/clientes';

@Injectable()
export class VersionamientoProductosService {
  clientes: any[] = [];
  clientesCopia: any[] = [];
  totalPaginas: number = 0;
  progreso: number = 0;
  paginaActual: number = 0;
  cantidadPorPagina: number = 10;
  barraVisible: boolean = false;
  cargando: boolean = false;

  constructor(private serviciUsuario: UsuariosProvider, private utils: ClientesProvider, private storage: Storage) {}

  // 🔹 Buscar todos los productos paginados por empresa
  async buscarProductosPorEmpresa() {
    let companiasId = await this.storage.get('companiasId');
    this.barraVisible = true;
    this.paginaActual = this.paginaActual === 0 ? 0 : this.paginaActual

    this.utils.buscarProductosPorEmpresaPaginado(companiasId, this.paginaActual, this.cantidadPorPagina)
      .subscribe((respuesta: any) => {
        const totalRegistrosJson = JSON.parse(respuesta['_body']).data[0];
        const totalRegistros = totalRegistrosJson[0].totalRegistros;
        this.totalPaginas = totalRegistrosJson[0].totalPaginas;
        this.progreso = 0;
        this.clientes = []; // Limpia el array de clientes
        this.clientesCopia = [];
        this.cargarProductosPaginados(totalRegistros);
      }, error => {
        console.log(error);
      });
  }

  // 🔹 Cargar clientes paginados y concatenarlos
  async cargarProductosPaginados(totalRegistros: number) {
    let companiasId = await this.storage.get('companiasId');

    if (this.paginaActual <= this.totalPaginas) {
      this.utils.buscarProductosPorEmpresaPaginado(companiasId, this.paginaActual, this.cantidadPorPagina)
        .subscribe((data: any) => {
          const clientesPagina =  JSON.parse(data['_body']).data;
          this.clientesCopia = [...this.clientesCopia, ...clientesPagina];

          const registrosCargados = this.clientesCopia.length;
          const totalRegistrosEsperados = Number(this.totalPaginas) * Number(this.cantidadPorPagina);
          this.progreso = Math.min(Math.max((registrosCargados / totalRegistrosEsperados) * 100, 0.01), 100);

          setTimeout(() => {
            // Aquí podrías agregar un evento o algún otro mecanismo para notificar cambios
          }, 0);

          this.paginaActual++;
          this.cargarProductosPaginados(totalRegistros); // Llamada recursiva hasta cargar todos los registros
        }, error => {
          console.log(error);
          this.clientes = [];
          this.clientesCopia = [];
          this.barraVisible = false;
        });
    } else {
      console.log('Se han cargado todos los clientes.');
      for (let i = 0; i < this.clientesCopia.length; i++) {
        this.clientes.push(...this.clientesCopia[i]);  // Añadimos cada conjunto de clientes al array 'this.clientes'
      }
      this.cargando = false;
      this.barraVisible = false;

      // Inicia el proceso de versionamiento de productos
      await this.versionarProductos(this.clientes);
    }
  }

//   async cargarProductosPaginados(totalRegistros: number) {
//     let companiasId = await this.storage.get('companiasId');

//     while (this.paginaActual <= this.totalPaginas) {
//         try {
//             let data: any = await this.utils.buscarProductosPorEmpresaPaginado(companiasId, this.paginaActual, this.cantidadPorPagina).toPromise();
//             const clientesPagina = JSON.parse(data['_body']).data;

//             this.clientesCopia = [...this.clientesCopia, ...clientesPagina];

//             const registrosCargados = this.clientesCopia.length;
//             const totalRegistrosEsperados = Number(this.totalPaginas) * Number(this.cantidadPorPagina);
//             this.progreso = Math.min(Math.max((registrosCargados / totalRegistrosEsperados) * 100, 0.01), 100);

//             this.paginaActual++;

//         } catch (error) {
//             console.log(error);
//             this.clientes = [];
//             this.clientesCopia = [];
//             this.barraVisible = false;
//             return; // Salir de la función si hay un error
//         }
//     }

//     console.log('Se han cargado todos los clientes.');
//     this.clientes = [...this.clientesCopia]; // Copiamos los datos finales a this.clientes
//     this.cargando = false;
//     this.barraVisible = false;

//     // Esperamos a que termine el versionamiento de productos
//     await this.versionarProductos(this.clientes);
// }


  // 🔹 Versionar productos (misma lógica que antes)
  async versionarProductos(clientes: any[]) {
    let companiasId = await this.storage.get('companiasId');

    let valores: any = await this.serviciUsuario.buscarCambiosEnLosProductos(companiasId);
    let productosGuardados = JSON.parse(valores['_body']);

    if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length === 0) {
      await this.versionarProductosInicial(clientes);
      console.log('Se guardaron todos los productos por primera vez.');
    } else {
      this.tienenDiferencias(clientes, companiasId);
    }
  }

  async versionarProductosInicial(productos: any[]) {
    const productosVersionados = productos.map((producto) => ({
      ...producto,
      historial: [{
        nombreCompleto: producto.nombreCompleto,
        existenciasActuales: producto.existenciasActuales,
        existenciasMinimas: producto.existenciasMinimas,
        valorVenta: producto.valorVenta,
        costo: producto.costo,
        fecha: new Date().toISOString(),
        cambios: null,
      }]
    }));

    let companiasId = await this.storage.get('companiasId');
    let usuariosId = await this.storage.get('usuariosId');

    if (productosVersionados.length > 0) {
      await Promise.all(productosVersionados.map(async (producto) => {
        if (producto.productosId == undefined) {
          return;
        }
        await this.serviciUsuario.guardarCambiosEnLosProductos(
          companiasId,
          usuariosId,
          producto.productosId,
          producto.nombreCompleto,
          producto.existenciasActuales,
          producto.existenciasMinimas,
          producto.valorVenta,
          producto.costo == null ? 0 : producto.costo,
          producto.cambios
        );
      }));
    }
  }

  async tienenDiferencias(productosYaPrecargados: any[], companiasId: any) {
    let usuariosId = await this.storage.get('usuariosId');

    let dataProductosGuardados = await this.serviciUsuario.buscarProductosNuevosCambiosEnLosProductos(companiasId);
    let productosGuardados = dataProductosGuardados.json();

    let dataUltimosCambios = await this.serviciUsuario.buscarUltimosCambiosProductos(companiasId);
    let ultimosCambios = dataUltimosCambios.json();

    if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length > 0) {
      await Promise.all(productosGuardados.data[0].map(async (nuevoProducto) => {
        if (!nuevoProducto.productosId) return;

        await this.serviciUsuario.guardarCambiosEnLosProductos(
          companiasId,
          usuariosId,
          nuevoProducto.productosId,
          nuevoProducto.nombreCompleto,
          nuevoProducto.existenciasActuales,
          nuevoProducto.existenciasMinimas,
          nuevoProducto.valorVenta,
          nuevoProducto.costo == null ? 0 : nuevoProducto.costo,
          null
        );
      }));
    }

    if (ultimosCambios && ultimosCambios.data && ultimosCambios.data[0].length > 0) {
      await Promise.all(ultimosCambios.data[0].map(async (productoAnterior) => {
        let productoPrecargado = productosYaPrecargados.find(p => p.productosId == productoAnterior.productosId);
        if (!productoPrecargado) return;
        let cambiosDetectados: any = {};
        ['nombreCompleto', 'existenciasActuales', 'existenciasMinimas', 'valorVenta', 'costo'].forEach(campo => {
          if (productoAnterior[campo] !== productoPrecargado[campo]) {
            cambiosDetectados[campo] = {
              antes: productoAnterior[campo],
              ahora: productoPrecargado[campo]
            };
          }
        });

        if (Object.keys(cambiosDetectados).length > 0) {
          await this.serviciUsuario.guardarCambiosEnLosProductos(
            companiasId,
            usuariosId,
            productoAnterior.productosId,
            productoPrecargado.nombreCompleto,
            productoPrecargado.existenciasActuales,
            productoPrecargado.existenciasMinimas,
            productoPrecargado.valorVenta,
            productoPrecargado.costo == null ? 0 : productoPrecargado.costo,
            JSON.stringify(cambiosDetectados)
          );
        }
      }));
    }

    console.log('Proceso finalizado: productos nuevos y cambios detectados fueron guardados.');
  }
}



// WEBPACK FOOTER //
// ./src/providers/versionamiento/versionamiento-productos-service.ts